"use client";

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";
import { hasActivity, subscribeActivity } from "./activityTracker";

/** Reactive `hasActivity` — re-renders when activity is marked in this tab. */
export function useHasActivity(uid) {
  const $ = _c(2);
  let t0;
  if ($[0] !== uid) {
    t0 = () => uid ? hasActivity(uid) : false;
    $[0] = uid;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSyncExternalStore(subscribeActivity, t0, _temp);
}
function _temp() {
  return false;
}